import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Heading } from 'components/Heading/Heading';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';
import { SearchContainer } from 'features/Search/SearchContainer';
import { messages } from './VenueSupply.messages';

export const VenueSupply = ({ shouldHide }) => {
  if (shouldHide) return null;

  return (
    <div className="VenueSupply">
      <div className="VenueSupply__top-section">
        <Heading className="VenueSupply__title">
          <LocalizableMessage message={messages.title} />
        </Heading>
        <p className="mt-regular qa-subtitle">
          <LocalizableMessage message={messages.subtitle} />
        </p>
        <Link className="mb-regular bt bt--lg bt--primary" to="/search" target="_self">
          <LocalizableMessage message={messages.link} />
        </Link>
      </div>
      <SearchContainer isInVenueSupply />
    </div>
  );
};

VenueSupply.propTypes = {
  shouldHide: PropTypes.bool,
};
